import * as React from 'react';
import { useSelector } from 'react-redux';

import { useScrollRef } from './hooks';
import { ChatWindowLayout } from '../../components/ChatWindowLayout';
import { currentOpenChatSelector, hostTypeSelector } from '../../selectors';
import { ERequestApiStatus } from '../../types/appState';
import { EHostType } from '../../types/hostType';
import { useApplicationContext } from '../../utils/applicationContext';
import { ChatHeaderOfferContainer } from '../ChatHeaderOfferContainer';
import { ChatHeaderUserContainer } from '../ChatHeaderUserContainer';
import { ChatScrollContainer } from '../ChatScrollContainer';
import { ChatWindowErrorContainer } from '../ChatWindowErrorContainer';
import { ChatWindowInitialContainer } from '../ChatWindowInitialContainer';
import { FullscreenGallery } from '../FullscreenGallery';
import { MessageInputFieldContainer } from '../MessageInputFieldContainer';
import { ScammerAlertContainer } from '../ScammerAlertContainer';
import { UnlockChatButtonContainer } from '../UnlockChatButtonContainer';

export const ChatWindowContainer: React.FC = () => {
  const currentChat = useSelector(currentOpenChatSelector);
  const hostType = useSelector(hostTypeSelector);

  const { config } = useApplicationContext();

  const status = currentChat ? currentChat.status : ERequestApiStatus.Initial;
  const backgroundImageUrl = config.get<string>('frontend-chats.backgroundImage');
  const { scrollRef, scrollToBottom, onScrollHeightChange } = useScrollRef();

  if (status === ERequestApiStatus.Initial && hostType !== EHostType.Frame) {
    return <ChatWindowInitialContainer />;
  }

  return (
    <ChatWindowLayout
      backgroundImageUrl={backgroundImageUrl}
      headerNode={
        <>
          <FullscreenGallery />
          <ScammerAlertContainer />
          <ChatHeaderUserContainer />
          <ChatHeaderOfferContainer />
          <ChatWindowErrorContainer />
        </>
      }
      bodyNode={<ChatScrollContainer scrollRef={scrollRef} scrollToBottom={scrollToBottom} />}
      footerNode={
        <>
          <UnlockChatButtonContainer />
          <MessageInputFieldContainer onHeightChange={onScrollHeightChange} />
        </>
      }
    />
  );
};
